<div class="progress-wrapper">
  <div class="progress-container">
    <div class="progressing" [ngStyle]="{ width: (progress.value / progress.total) * 100 + '%' }"></div>
  </div>
  <span *ngIf="!hideLabel" class="label">{{ progress.label }}&nbsp;</span>
</div>
